<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Visualizar Estação de Trabalho</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="title">
                            <span class="required">*</span> Titulo:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="workstations.title"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="Company">
                            <span class="required">*</span> Empresa
                          </label>
                          <select
                            v-model="workstations.company_id"
                            disabled
                            class="form-control"
                          >
                            <option
                              v-for="company in companies"
                              :value="company.id"
                              :key="company.id"
                            >
                              {{ company.company_name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="tag">
                            <span class="required">*</span> Tag:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="workstations.tag"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="branch_id">
                            <span class="required">*</span> Filial/Prédio:
                          </label>
                          <select
                            v-model="workstations.branch_id"
                            disabled
                            class="form-control"
                          >
                            <option
                              v-for="branch in branches"
                              :value="branch.id"
                              :key="branch.id"
                            >
                              {{ branch.title }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="number_room">
                            <span class="required">*</span> Nº da Estação:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="workstations.number_room"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="floor">
                            <span class="required">*</span> Andar:
                          </label>
                          <input
                            disabled
                            type="text"
                            class="form-control"
                            v-model="workstations.floor"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="capacity">
                            <span class="required">*</span> Quantidade de
                            Posições:
                          </label>
                          <input
                            disabled
                            type="number"
                            class="form-control"
                            v-model="workstations.capacity"
                            autocomplete="new-password"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-8">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Descrição:
                          </label>
                          <textarea
                            disabled
                            v-model="workstations.description"
                            name="description"
                            cols="100"
                            class="form-control"
                            rows="10"
                            autocomplete="new-password"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>
                            Grupos de usuário com permissão para reservar esta estação:
                          </label>
                          <v-select 
                          disabled
                          multiple
                          label="title"
                          v-model="workstations.users_groups"
                          :options=users_groups>
                          </v-select> 
                        </div>
                      </div>
                      <div class="col-md-4 justify-content-center">
                        <label for="description">
                          <span class="required">*</span> QRCode Geral da
                          Estação:
                        </label>
                        <vue-qrcode
                          class="photo-qrcode"
                          errorCorrectionLevel="L"
                          :value="workstations.id + ''"
                        />
                        <div align="center">
                          <a
                            :href="workstations.qrcode_download"
                            target="_blank"
                            class="btn btn-back centered"
                          >
                            Download do QrCode
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="row"></div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="WorkstationDetails"
                            >Contém na Estação:</label
                          >
                          <br />
                        </div>
                      </div>
                      <br />
                      <br />
                      <div
                        class="col-md-1 lg-check"
                        style="text-align: center"
                        v-for="detail in details"
                        :key="detail.id"
                      >
                        <input
                          type="checkbox"
                          :value="detail.id"
                          v-model="checkeds"
                          :id="detail.id"
                          disabled
                        />
                        <label :for="detail.id">{{ detail.title }}</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 mb-3">
                        QrCode por estação de trabalho
                      </div>
                      <div
                        class="col-2 border2 ml-3"
                        v-for="place in workstations.places"
                        :key="place.id"
                        align="center"
                      >
                        <label class="titlePosition">{{ place.title }}</label>
                        <br />
                        <label class="subtitlePosition"
                          >Código Posição: {{ place.id }}</label
                        >
                        <vue-qrcode
                          class="photo-qrcode-position"
                          errorCorrectionLevel="L"
                          :value="place.id + ''"
                        />
                        <div align="center">
                          <a
                            :href="place.qrcode_download"
                            target="_blank"
                            class="btn btn-back centered mtn-2 mb-4"
                          >
                            Download do QrCode
                          </a>
                        </div>
                      </div>

                      <div class="col-12 mt-5 centered">
                        <a
                          :href="workstations.qrcode_pool_download"
                          target="_blank"
                          class="btn btn-back centered mtn-2 mb-4"
                        >
                          Baixar todos os QrCode's
                        </a>
                      </div>
                    </div>
                    <br />
                    <br />
                    <hr />
                    <div class="row">
                      <div class="col-md-4">
                        <label for="roomPic">Foto da Estação de Trabalho</label>
                        <div class="room-img">
                          <img
                            v-if="workstations.photo == ''"
                            class="photo-sala"
                          />
                          <img
                            v-else
                            :src="workstations.photo"
                            class="photo-sala"
                          />
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="block text-right">
                      <router-link to="/workstations" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
import VueQrcode from "vue-qrcode";
export default {
  data() {
    return {
      previewImage: null,
      workstations: {
        photo: "",
        title: "",
        tag: "",
        company_id: "",
        floor: "",
        capacity: "",
        users_groups: [],
      },
      details: [],
      checkeds: [],
      companies: [],
      branches: [],
      users_groups: []
    };
  },
  methods: {
    getWorkstationDetails: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "workstation_details/?paginated=false&company_id=" +
        id;

      self.$http
        .get(api)
        .then((response) => {
          self.details = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "branches/?paginated=false&company_id=" +
        self.workstations.company_id;

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
          self.getWorkstationDetails(self.workstations.company_id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsersGroups: function (id) {
      const self = this;
      const api = self.$store.state.api + "users_groups/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users_groups = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getWorkstations: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "workstations/" +
        id +
        "?with[]=details&with[]=places&with[]=users_groups";

      self.$http
        .get(api)
        .then((response) => {
          self.workstations = response.data.data[0];
          self.getWorkstationDetails(self.workstations.company_id);
          self.workstations.details.forEach((detail, index) => {
            self.checkeds.push(detail.detail_id);
          });
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getCompanies();
    self.getBranches();
    let id = self.$route.params.id;
    if (id) {
      self.getWorkstations(id);
      self.getWorkstationDetails();
    }
    self.getUsersGroups();
  },
  components: {
    vSelect,
    VueQrcode,
  },
};
</script>
<style scoped>
.photo-sala {
  max-height: 300px;
  height: 200px;
  text-shadow: white 0px 0px 2px;
  font-size: 16px;
  background-size: 150px;
}

.photo-qrcode {
  width: 200px;
  height: 200px;
  text-shadow: white 0px 0px 2px;
  font-size: 16px;
  background-size: 150px;
}
.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.photo {
  display: flex;
  border-radius: 20px;
  max-width: 400px;
  max-height: 200px;
  object-fit: cover;
}
.preview {
  display: inline-block;
  border-radius: 20px;
  max-width: 200px;
  max-height: 100px;
  object-fit: cover;
}
.inlinee {
  display: inline-block;
}

.lg-check {
  margin: 20px;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #4b2e8f;
  border-radius: 0.25rem;
}
input[type="checkbox"]:checked + label {
  border: 2px solid #4b2e8f;
  color: #fff;
  background-color: #4b2e8f;
  font-style: normal;
}

.border2 {
  border: #4b2e8f solid 1px;
  font-weight: bold;
  font-size: 18px;
}

.photo-qrcode-position {
  width: 120px;
  height: 120px;
  text-shadow: white 0px 0px 2px;
  font-size: 16px;
  background-size: 150px;
}

.titlePosition {
  margin-top: 15px;
  margin-bottom: -7px;
}
.subtitlePosition {
  font-weight: 100 !important;
}
.mtn-2 {
  margin-top: -7px;
}
</style>


// WEBPACK FOOTER //
// src/components/Workstations/View.vue